import React from 'react';
import { SmallText, BodyText } from '../../../components/brand/BrandTypography';
import { PrimaryButton, TertiaryButton } from '../../../components/brand/BrandButton';

const SubscribersTab = ({ subscribersData, subscribersLoading, onFetch }) => {
    return (
        <div className="space-y-6">
            <div className="mb-4 p-4 bg-[#7D8E95]/20 rounded-xl border border-[#1D6B6B]/20">
                <SmallText className="text-[#1D6B6B]">
                    <strong>Subscriber Management</strong> - View and manage your paying subscribers. Billing handled by Stripe.
                </SmallText>
            </div>
            
            {subscribersLoading ? (
                <div className="text-center py-12">
                    <div className="w-3 h-3 rounded-full bg-[#1D6B6B] animate-pulse mx-auto mb-4" />
                    <SmallText className="text-[#7D8E95]">Loading subscribers...</SmallText>
                </div>
            ) : subscribersData.subscribers.length === 0 ? (
                <div className="text-center py-12">
                    <BodyText className="text-[#7D8E95] mb-4">No subscribers yet</BodyText>
                    <TertiaryButton onClick={onFetch}>Refresh</TertiaryButton>
                </div>
            ) : (
                <>
                    {/* Stats Cards */}
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
                        <div className="bg-white rounded-xl border border-[#FFBB98] p-4 text-center">
                            <div className="text-2xl font-bold text-[#1D6B6B]">{subscribersData.stats.total || 0}</div>
                            <SmallText className="text-[#7D8E95]">Total Paying</SmallText>
                        </div>
                        <div className="bg-white rounded-xl border border-[#FFBB98] p-4 text-center">
                            <div className="text-2xl font-bold text-[#7D8E95]">{subscribersData.stats.support_plus || 0}</div>
                            <SmallText className="text-[#7D8E95]">Support+</SmallText>
                        </div>
                        <div className="bg-white rounded-xl border border-[#FFBB98] p-4 text-center">
                            <div className="text-2xl font-bold text-[#7D8E95]">{subscribersData.stats.partner || 0}</div>
                            <SmallText className="text-[#7D8E95]">Deep Support</SmallText>
                        </div>
                        <div className="bg-white rounded-xl border border-[#FFBB98] p-4 text-center">
                            <div className="text-2xl font-bold text-[#FFBB98]">{subscribersData.stats.canceling || 0}</div>
                            <SmallText className="text-[#7D8E95]">Canceling</SmallText>
                        </div>
                    </div>
                    
                    {/* Subscriber List */}
                    <div className="space-y-3">
                        {subscribersData.subscribers.map(sub => (
                            <div key={sub.id} className="bg-white rounded-xl border border-[#FFBB98] p-4">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-3">
                                        <div className={`w-10 h-10 rounded-full flex items-center justify-center text-white font-medium ${
                                            sub.tier === 'partner' ? 'bg-[#7D8E95]' : 'bg-[#7D8E95]'
                                        }`}>
                                            {sub.name?.charAt(0) || sub.email?.charAt(0) || '?'}
                                        </div>
                                        <div>
                                            <div className="font-medium text-[#1D6B6B]">{sub.name || 'No name'}</div>
                                            <SmallText className="text-[#7D8E95]">{sub.email}</SmallText>
                                        </div>
                                    </div>
                                    <div className="text-right">
                                        <span className={`px-2 py-1 text-xs rounded-full ${
                                            sub.tier === 'partner' ? 'bg-[#7D8E95] text-[#7D8E95]' : 'bg-[#7D8E95] text-[#7D8E95]'
                                        }`}>
                                            {sub.tier === 'partner' ? 'Deep Support' : 'Support+'}
                                        </span>
                                        {sub.cancel_at_period_end && (
                                            <div className="text-xs text-[#FFBB98] mt-1">Canceling</div>
                                        )}
                                        <SmallText className="text-[#7D8E95] block mt-1">
                                            {sub.billing === 'yearly' ? 'Yearly' : 'Monthly'}
                                        </SmallText>
                                    </div>
                                </div>
                                {sub.subscribed_at && (
                                    <SmallText className="text-[#7D8E95] mt-2 block">
                                        Subscribed: {new Date(sub.subscribed_at).toLocaleDateString()}
                                    </SmallText>
                                )}
                            </div>
                        ))}
                    </div>
                    
                    <div className="text-center mt-6">
                        <TertiaryButton onClick={onFetch}>
                            Refresh List
                        </TertiaryButton>
                    </div>
                </>
            )}
            
            {subscribersData.subscribers.length === 0 && !subscribersLoading && (
                <div className="text-center">
                    <PrimaryButton onClick={onFetch}>
                        Load Subscribers
                    </PrimaryButton>
                </div>
            )}
        </div>
    );
};

export default SubscribersTab;
